<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Invoice Item</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="invoiceItem.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Quantity
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="invoiceItem.quantity" />
                                    <validation-error :errors="apiValidationErrors.quantity" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Work Item
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="invoiceItem.workItem.id" name="work_item_id">
                                        <md-option
                                                v-for="workitem in available_workItems_dropdown"
                                                :key="workitem.id"
                                                :value="workitem.id"
                                        >
                                            {{ workitem.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Invoice
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="invoiceItem.invoice.id" name="invoice_id">
                                        <md-option
                                                v-for="invoice in available_invoice_dropdown"
                                                :key="invoice.id"
                                                :value="invoice.id"
                                        >
                                            {{ invoice.invoice_number }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Labour Schedule
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="invoiceItem.labourSchedule.id" name="labour_schedule_id">
                                        <md-option
                                                v-for="labourSchedule in available_labourSchedule_dropdown"
                                                :key="labourSchedule.id"
                                                :value="labourSchedule.id"
                                        >
                                            {{ labourSchedule.takeon_number }}
                                        </md-option>
                                    </md-select>
                                    <validation-error :errors="apiValidationErrors.labour_schedule_id" />
                                </md-field>
                            </div>
                        </div>


                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Edit Invoice Item</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        invoiceItem: {
            type: 'invoiceItems',
            name: null,
            quantity: null,
            workItem: {
                type:'workItems',
                id: null,
                name:null,
            },
            labourSchedule:{
                type:'labourerSchedules',
                id:null,
                takeon_number:null,
            },
            invoice: {
                type:'invoices',
                id: null,
                invoice_number:null,
                invoice_date:null,
            }
        },
        available_workItems_dropdown: [],
        available_invoice_dropdown: [],
        available_labourSchedule_dropdown: [],
    }),
    created () {
        this.get();
        this.getWorkItemDropDowns();
        this.getInvoiceDropDowns();
        this.getlabourerScheduleDropDown();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('invoiceItems/get', id);
                this.invoiceItem = this.$store.getters['invoiceItems/invoiceItem'];
                console.log(this.invoiceItem);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('invoiceItems/update', this.invoiceItem);
                await this.$store.dispatch(
                    'alerts/success',
                    'Invoice Item updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Invoice Items List' });
        },
        getWorkItemDropDowns () {
            this.$store.dispatch('workItems/list').then(() => {
                this.available_workItems_dropdown = this.$store.getters['workItems/dropdown'];
                if (this.available_workItems_dropdown && this.available_workItems_dropdown.length) {
                    this.invoiceItem.work_item_id = this.available_workItems_dropdown[0].id;
                }
            });
        },
        getInvoiceDropDowns () {
            this.$store.dispatch('invoices/list').then(() => {
                this.available_invoice_dropdown = this.$store.getters['invoices/dropdown'];
                if (this.available_invoice_dropdown && this.available_invoice_dropdown.length) {
                    this.invoiceItem.invoice_id = this.available_invoice_dropdown[0].id;
                }
            });
        },
        getlabourerScheduleDropDown () {
            this.$store.dispatch('labourSchedules/list').then(() => {
                this.available_labourSchedule_dropdown = this.$store.getters['labourSchedules/dropdown'];
                if (this.available_labourSchedule_dropdown && this.available_labourSchedule_dropdown.length) {
                    this.invoiceItem.labour_schedule_id = this.available_labourSchedule_dropdown[0].id;
                }
            });
        },
    },
};
</script>
